import { SubjectInfo } from "@/pages/SchoolDiagnoseReport/type";
import React, { useEffect } from "react";
import { InputNumber, Checkbox } from "antd";
type SubjectScoreType = {
  subjectAndScoreList: Array<SubjectInfo>;
  setSubjectAndScoreList: ([]) => void;
  FormItem: any;
  // preTotal: React.MutableRefObject<number>;
};

const SubjectScore = (props: SubjectScoreType) => {
  const {
    subjectAndScoreList = [],
    setSubjectAndScoreList = () => {},
    FormItem,
    // preTotal,
  } = props;

  //更改主攻科目状态
  const handleMainSubject = (index: number) => {
    subjectAndScoreList[index].is_main_attack =
      !subjectAndScoreList[index].is_main_attack;
    setSubjectAndScoreList([...subjectAndScoreList]);
  };
  //更改提升空间
  const handleAdd = (index: number, value: number) => {
    subjectAndScoreList[subjectAndScoreList.length - 1].improve_score += value
      ? value - subjectAndScoreList[index].improve_score
      : 0 - subjectAndScoreList[index].improve_score;
    // subjectAndScoreList[index].improve_score = value ? value : 0;
    subjectAndScoreList[index].improve_score = value;
    setSubjectAndScoreList([...subjectAndScoreList]);
  };
  return (
    <div className="school_diagnose__score">
      <div className="school_diagnose__right-title">
        <div className="school_diagnose__right-title-prompt"></div>
        <span>科目分数</span>
      </div>
      <div
        className="school_diagnose__score-info-wrapper"
        style={{ width: "100%" }}
      >
        {subjectAndScoreList.map((item: SubjectInfo, index: number) => {
          return (
            <div
              className={
                index === 0
                  ? "school_diagnose__score-info score-first__child"
                  : "school_diagnose__score-info"
              }
              key={String(index)}
            >
              <span>{item.subject_name}:</span>
              <span style={{ width: "120px" }}>当前分数：{item.score}</span>
              <span style={{ width: "120px" }}>
                目标分数：{item.score + item.improve_score}
              </span>
              <span style={{ width: "100px" }}>
                满分：{item.full_score}&nbsp;分
              </span>
              <div className="school_diagnose__score-add">
                {/*<span>提升空间&nbsp;</span>*/}
                {index === subjectAndScoreList.length - 1 ? (
                  <span>提升空间：{item.improve_score}分</span>
                ) : (
                  <FormItem
                    label="提升空间:"
                    // name={"improve_score" + index}
                    name={"improve_score" + index}
                    initialValue={item.improve_score}
                    rules={[
                      {
                        required: true,
                        // message: "Please input your username!",
                      },
                    ]}
                  >
                    <InputNumber
                      style={{
                        width: "90px",
                      }}
                      min={0}
                      value={item.improve_score}
                      onChange={(value) => {
                        handleAdd(index, value);
                      }}
                    />
                  </FormItem>
                )}
                <span
                  style={{
                    visibility:
                      index === subjectAndScoreList.length - 1
                        ? "hidden"
                        : "inherit",
                  }}
                >
                  &nbsp;分
                </span>
              </div>
              <div
                className="school_diagnose__main"
                style={{
                  width: "100px",
                  visibility:
                    index === subjectAndScoreList.length - 1
                      ? "hidden"
                      : "inherit",
                }}
              >
                <span>主攻科目&nbsp;</span>
                <Checkbox
                  checked={item.is_main_attack}
                  onChange={() => {
                    handleMainSubject(index);
                  }}
                ></Checkbox>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SubjectScore;
